import { Box, AspectRatio, Image } from "@chakra-ui/react";
import { QuoteMark } from "components/atoms/QuoteMark";

export const CenterTestimonial = () => {
  return (
    <Box textAlign="center">
      <Box
        width={12}
        height={12}
        display="inline-block"
        rounded="full"
        overflow="hidden"
        mb={2}
      >
        <AspectRatio ratio={1}>
          <Image src="https://staging.lead.pro/images/ben.jpeg" />
        </AspectRatio>
      </Box>
      <Box
        fontSize="3xl"
        mb={4}
        maxW="3xl"
        lineHeight="1.5"
        fontWeight={400}
        mx="auto"
        position="relative"
      >
        <Box position="absolute" opacity={0.15} left={-3}>
          <QuoteMark />
        </Box>
        Autocaller makes sure we call valuation leads before any other agent,
        since using it we are booking in 5-7 more valuation appointments every
        month.
      </Box>{" "}
      <Box>
        <Box fontWeight={700} lineHeight="none" mb={2} fontSize="lg">
          Benjamin Churchill
        </Box>
        <Box color="gray.500" lineHeight="none">
          Harry Harper Estate Agents
        </Box>
      </Box>
    </Box>
  );
};
